// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__3U2GT","alertAnimation":"Alert_alertAnimation__1fhzt"};